import Text from "./components/text";
import Paragraph from "./components/paragraph";
import Hyperlink from "./components/hyperlink";

import Quote from "./components/quote";
import ListItem from "./components/list-item";
import getList from "./components/list";
import getHeading from "./components/heading";

const mappings = {
  text: Text,
  paragraph: Paragraph,
  hyperlink: Hyperlink,

  blockquote: Quote,
  "unordered-list": getList("ul"),
  "ordered-list": getList("ol"),
  "list-item": ListItem,
  "heading-2": getHeading(2),
  "heading-3": getHeading(3),
  "heading-4": getHeading(4),
  "heading-5": getHeading(5),
  "heading-6": getHeading(6),
};

const RichText = ({ content }) =>
  content.map((item, i) => {
    const { nodeType } = item;
    const InnerComponent = mappings[nodeType];
    return InnerComponent ? <InnerComponent {...item} key={i} /> : null;
  });

export default RichText;
